  <section class="container pt-6 pb-12 flex-col gap-2 inline-flex">
    <h3 class="h2 text-black mb-6 lg:mb-0">
      {{ "shared.headers.financeThisProperty" | transloco }}
    </h3>
    <span class="text-gray-900 text-base">{{"shared.headers.financeThisPropertyOptions" | transloco }}</span>
    <div class="mb-8">
      <form>
        <div class="flex lg:flex-row flex-col items-center justify-between gap-12">
          <app-loan-calulator [calcValues]="initialCalcValues"></app-loan-calulator>
          <div class="flex flex-col items-center justify-center">
            <app-doughnut-chart [showEstimatedFees]="true"></app-doughnut-chart>
            <div class="mt-6 text-gray-700 font-semibold flex flex-row gap-2 text-xs">
              ΕΚΠΛΗΡΩΘΗΚΕ ΑΠΟ
              <img src="{{'assets/svgs/nbg-logo-black' + (activeLang === 'en' ? '-en': '') +'.svg'}}" alt="NBG Logo" />
            </div>
          </div>
        </div>
      </form>
    </div>
      <div class="flex flex-col md:flex-row gap-6 items-center">
        <a class="btn-primary" (click)="askFinancialServices('/loan-application')">{{
          "shared.anchors.loanApplication" | transloco }}</a>
        <a class="btn-secondary" (click)="askFinancialServices('/loan-eligibility')">
          {{ "shared.anchors.loanEligibility" | transloco }}
        </a>
      </div>
  </section>
